import * as React from "react"

const H2Title = ({ title, titleSp, subtitle, description }) => {
  return (
    <>
      <div className="c-title">
        <p>
          <span>{subtitle}</span>
        </p>
        <h2 className={titleSp ? "c-title-desktop" : ""}>{title}</h2>
        {titleSp && <h2 className="c-title-mobile">{titleSp}</h2>}
        {description && <p>{description}</p>}
      </div>
    </>
  )
}

export default H2Title
